export default function initLottie() {
  // Investors loop start after scroll
  const lottiePlayer = document.getElementById("investors-loop")

  if (lottiePlayer) {
    // Add condition to check if lottiePlayer exists
    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Add a small delay before starting the animation
            setTimeout(() => {
              lottiePlayer.play()
            }, 600) // Delay in milliseconds (e.g., 300ms)
          } else {
            lottiePlayer.stop()
          }
        })
      })

      observer.observe(lottiePlayer)
    } else {
      // Fallback for browsers that do not support IntersectionObserver
      lottiePlayer.play()
    }
  }
}
